import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Header from './Header';
import TimelineSwiper from './TimelineSwiper';
import Logos from 'components/Elements/LogosList';

const Business = ({ data }) => {
  const {
    allFile: { nodes },
  } = useStaticQuery(graphql`
    query getBussinesLogos {
      allFile(filter: { relativeDirectory: { eq: "common/logos" } }) {
        nodes {
          name
          relativePath
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
      }
    }
  `);

  return (
    <section>
      <div className="cr-wrap">
        <Header data={data.header} />
        <TimelineSwiper data={data.swiper} />
        <Logos logos={nodes} />
      </div>
    </section>
  );
};

export default Business;
